import { getCountryListRequest } from "@common";
import { createForm, fields, FormErrors, reactBinding } from "rd-redux-forms";
import { FetchingState } from "rd-redux-http";
import { ChartsDataState, defaultChartsDataState } from "./charts";

export interface ReportParametersFormFields {
    campaignId: string;
    clientId: string;
    fromDate: string;
    toDate: string;
}

export const reportParametersForm = createForm<ReportParametersFormFields>("REPORT PARAMETERS", {
    campaignId: fields.string(true),
    clientId: fields.string(true),
    fromDate: fields.string(false),
    toDate: fields.string(false)
});

export const reportParametersFormBindings = reactBinding()
    .default()
    .forAllFields()
    .onChange()
    .edit()
    .submit()
    .end()
    .withForm(reportParametersForm);

export function validateReportParameters(
    data: ReportParametersFormFields
): FormErrors<ReportParametersFormFields> | undefined {
    const result: FormErrors<ReportParametersFormFields> = { fields: {} };

    if (data.fromDate && !isValidDate(data.fromDate)) {
        result.fields["fromDate"] = ["Invalid date"];
    }

    if (data.toDate && !isValidDate(data.toDate)) {
        result.fields["toDate"] = ["Invalid date"];
    }

    if (data.fromDate && data.toDate) {
        const from = new Date(data.fromDate);
        const to = new Date(data.toDate);

        if (from > to) {
            result.fields["toDate"] = ["From Date Should Be Before To Date"];
        }
    }

    return Object.keys(result.fields).length ? result : undefined;
}

function isValidDate(date: string): boolean {
    const d = new Date(date);
    return d instanceof Date && !isNaN(d as any);
}

export interface GeographicReportState {
    countrySVGs: {}[];
}

export const defaultGeographicReportState: GeographicReportState = {
    countrySVGs: undefined
};

export interface ReportState {
    form: typeof reportParametersForm.types.state;

    chartData: ChartsDataState;
    countries: typeof getCountryListRequest.types.reduxState;
    geographicReport: GeographicReportState;
    downloadState: null | "LOADING" | "LOADED" | "ERROR";
}

export const defaultReportState: ReportState = {
    form: reportParametersForm.state.empty(),
    chartData: defaultChartsDataState,
    countries: { fetchState: FetchingState.INITIAL },
    geographicReport: defaultGeographicReportState,
    downloadState: null
};
